<template>
  <div>
    <form>
      <label for="type-name">
        Nome do revendedor:
        <input type="text" id="type-name" v-model="newDealer.name" placeholder="Açaí Brasil" />
      </label>

      Selecione os lotes:
      <ul>
        <li v-for="batch in batches" :key="batch.id">
          <input type="checkbox" v-model="newDealer.batches" :value="batch.id" :disabled="batch.is_available === 0" /> {{ batch.name }}
            <span style="font-size: 10px;" v-if="batch.is_available === 0">(Desativado)</span>
        </li>
      </ul>
      <button class="btn btn-success" type="button" v-on:click="create">Criar revendedor</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'OrganizerNewDealer',
  props: [
    'organizer',
    'batches'
  ],
  data () {
    return {
      newDealer: {
        name: null,
        batches: []
      }
    }
  },
  methods: {
    create () {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/dealers'
      this.$http.post(url, this.newDealer).then(res => {
        this.$emit('dealer-created', res.body)
        this.newDealer.name = null
        this.newDealer.batches = []
      }, err => {
        alert(err.body.message)
        console.log(err)
      })
    }
  }
}
</script>
